import React, { Component } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Label } from 'reactstrap';

class EditUsername extends Component {
  state = {
    disabled: true
  }

  handleValueChange = () => {
    this.setState({ disabled: false })
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="md">
        <ModalHeader toggle={this.props.toggle}>Change Username</ModalHeader>
        <ModalBody>

          <FormGroup>
            <Label for="newUsername">Current Username</Label>
            <Input
              type="text"
              name="current-username"
              id="currentUsername"
              defaultValue="kylefoundry"
              onChange={this.handleValueChange}
              disabled
            />
          </FormGroup>

          <FormGroup>
            <Label for="newUsername">New Username</Label>
            <Input
              type="text"
              name="new-username"
              id="newUsername"
              onChange={this.handleValueChange}
            />
          </FormGroup>

          <FormGroup>
            <Label for="currentPassword">Current Password</Label>
            <Input
              type="password"
              name="current-password"
              id="currentPassword"
              onChange={this.handleValueChange}
            />
          </FormGroup>

          <Button color="primary" className="w-100 mt-1" disabled={this.state.disabled}>Change Username</Button>

        </ModalBody>
      </Modal>
    );
  }
}

export default EditUsername;
